/* eslint no-console:0 */

import "@hotwired/turbo-rails"
require("@rails/activestorage").start()

import LocalTime from "local-time"
LocalTime.config.locale = "de"
LocalTime.config.useFormat24 = true
LocalTime.start()

import "./config/chartjs"
import "./channels"
import "./controllers"
import "./src/**/*"
